module.exports = __webpack_public_path__ + "static/forecast/weather/daymodrain-b34a6d03bcc913e767cc4a847c4cb175.svg";